import styles from './ResponseMapping.module.css';

const PREVIEW_FAILURE_MESSAGE = "We couldn't produce a preview. Check the mapping and try again.";
const PREVIEW_LOADING_MESSAGE = 'Working…';

interface MappedResultPaneProps {
  previewFailed: boolean;
  mappedText: string | null;
}

export const MappedResultPane = ({ previewFailed, mappedText }: MappedResultPaneProps) => {
  if (previewFailed) {
    return <p className={styles.previewStatus}>{PREVIEW_FAILURE_MESSAGE}</p>;
  }
  if (mappedText === null) {
    return <p className={styles.previewStatus}>{PREVIEW_LOADING_MESSAGE}</p>;
  }
  return <pre className={styles.code}>{mappedText}</pre>;
};
